import { render, staticRenderFns } from "./TextMaterialViewModal.vue?vue&type=template&id=eb97225a&scoped=true"
import script from "./TextMaterialViewModal.vue?vue&type=script&lang=js"
export * from "./TextMaterialViewModal.vue?vue&type=script&lang=js"
import style0 from "./TextMaterialViewModal.vue?vue&type=style&index=0&id=eb97225a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb97225a",
  null
  
)

export default component.exports